import { ActionButtonProps, Box, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'

export const renderActionButtons = (
  props: ActionButtonProps,
  step: number,
  isLoading: boolean,
  onNextPress: () => void,
  onBackPress: () => void,
  addSingBeneficiaryReq: any,
  mid: string,
) => {
  const isValid = props?.isValid

  const handlerNextSubmit = () => {
    if (isValid) {
      if (step === 0) {
        onNextPress()
      } else if (step === 1) {
        addSingBeneficiaryReq(mid, props?.values)
      }
    }
  }
  console.log('props values', props?.values)
  return (
    <Box alignSelf="flex-end" flexDirection="row" justify="center">
      <ModBox
        w={112}
        h={40}
        testID="back"
        show={step === 1}
        onPress={onBackPress}
        justifyContent="center"
        underlayColor="TRANSPARENT"
        borderWidth={1}
        borderRadius={8}
        borderColor="BLUE"
        pv={5}
        ph={10}
        alignItems={'center'}>
        <Text fontFamily="jiotype-medium" fontSize={14} color="BLUE">
          {'Back'}
        </Text>
      </ModBox>
      <Spacer direction="horizontal" size={16} />
      <Box
        w={132}
        testID="verifyNSave"
        onPress={handlerNextSubmit}
        disabled={!isValid || isLoading}
        bg="BLUE"
        underlayColor="TRANSPARENT"
        opacity={isValid ? 1 : 0.5}
        pv={5}
        ph={18}
        borderRadius={6}
        justifyContent="center"
        alignItems={'center'}>
        {isLoading ? (
          <Loader color="WHITE" />
        ) : (
          <Text type={'body2'} fontWeight={'600'} fontSize={12} color="WHITE">
            {step === 0 ? 'Next ' : 'Verify & Save'}
          </Text>
        )}
      </Box>
    </Box>
  )
}
